import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { OrderStateServiceWrapper } from '../store/state/order/order.state.wrapper.service';
import { EnvironmentService } from '../services/environment.service';

@Injectable({ providedIn: 'root' })
export class OrderStepGuard implements CanActivate {
    constructor(private orderStateService: OrderStateServiceWrapper, private router: Router, private environmentService: EnvironmentService) { }

    canActivate(
        _route: ActivatedRouteSnapshot,
        routeState: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        if (this.environmentService.env.preventOrderStepJump === 'false') {
            return true;
        }
        const currentNav = this.router.getCurrentNavigation();
        // getCurrentNavigation() is only non-null during the navigation cycle
        const skip = currentNav?.extras.state?.['skipUrlValidation'];

        if (skip) {
            // This navigation explicitly asked to skip validation
            return true;
        }


        // Get the current step from the route data or path
        const route = routeState.url;
        // Check if the user is allowed to access this step
        if (this.orderStateService.isRouteAccessible(route)) {
            return true;
        }

        // Redirect to the last accessible step
        const currentRoute = this.orderStateService.getCurrentRoute();
        //const routePath = this.orderStateService.getRoutePathFromStep(currentRoute);
        return this.router.navigate([currentRoute]);
    }
}
